export default {
  REGISTER_START: 'auth/REGISTER_START',
  REGISTER_SUCCESS: 'auth/REGISTER_SUCCESS',
  REGISTER_FAILURE: 'auth/REGISTER_FAILURE',

  LOGOUT_START: 'auth/LOGOUT_START',
  LOGOUT_SUCCESS: 'auth/LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'auth/LOGOUT_FAILURE',

  //uncomment for team made backend
  // LOGIN_START: 'auth/LOGIN_START',
  // LOGIN_SUCCESS: 'auth/LOGIN_SUCCESS',
  // LOGIN_FAILURE: 'auth/LOGIN_FAILURE',

  // GET_CURRENT_START: 'auth/GET_CURRENT_START',
  // GET_CURRENT_SUCCESS: 'auth/GET_CURRENT_SUCCESS',
  // GET_CURRENT_FAILURE: 'auth/GET_CURRENT_FAILURE',

  // SET_USER_NAME_TO_STORE: 'auth/SET_USER_NAME_TO_STORE',
  // SET_TOKEN_IN_STORE: 'auth/SET_TOKEN_IN_STORE',
};
